export default __webpack_public_path__ + "static/media/plane.71c473d4.png";